module.exports = __webpack_public_path__ + "media/images/amenities_icons/pool-f50f47766a1fd6c28f2a92aa185a1a0a.svg";